var createStyledOptions = function createStyledOptions(skippedProps) {
  return {
    shouldForwardProp: function shouldForwardProp(prop) {
      return !prop.startsWith("$") && !skippedProps.has(prop);
    }
  };
};

export { createStyledOptions };
